var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFacebook = function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 18,
    fill: "none",
    viewBox: "0 0 19 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9.055 0a9.055 9.055 0 0 1 1.416 18v-6.328h2.11l.4-2.617h-2.51V7.313c.013-.701.372-1.372 1.476-1.372h1.14v-2.23s-1.035-.177-2.026-.177c-2.037 0-3.378 1.215-3.42 3.418l-.001.106v1.994H5.342v2.617h2.3v6.328A9.055 9.055 0 0 1 9.056 0"
  })));
};
export default SvgFacebook;